import { Pencil, Trash2 } from 'lucide-react';

import { cn } from '../../lib/utils';
import { Button } from '../ui/Button';
import type { EditRemoveActionsProps } from './types';

/** Ghost pencil + trash row actions. Labels carry the row identity for a11y. */
export function EditRemoveActions<TRow>({
  row,
  onEdit,
  onRemove,
  editLabel,
  removeLabel,
  size = 'default',
}: EditRemoveActionsProps<TRow>) {
  const sizeClass = size === 'compact' ? 'h-6 w-6' : undefined;

  return (
    <div className="flex items-center justify-end gap-1">
      {onEdit && (
        <Button
          type="button"
          variant="ghost"
          size="icon"
          aria-label={editLabel}
          // A row with `rowLink` navigates on any click that reaches it; this
          // action must not also fire that navigation.
          onClick={(e) => {
            e.stopPropagation();
            onEdit(row);
          }}
          className={cn(sizeClass)}
        >
          <Pencil className="h-4 w-4" />
        </Button>
      )}
      {onRemove && (
        <Button
          type="button"
          variant="ghost"
          size="icon"
          aria-label={removeLabel}
          onClick={(e) => {
            e.stopPropagation();
            onRemove(row);
          }}
          className={cn(sizeClass)}
        >
          <Trash2 className="h-4 w-4 text-destructive" />
        </Button>
      )}
    </div>
  );
}
